import React from 'react';
import formateText from '../../../../utils/Formate';

const DashboardPageTitle = ({text}) => {
    return (
        <h1 className='lg:text-5xl text-3xl lg:mb-24 mb-8 font-bold'>{formateText(text)}</h1>
    );
};

export default DashboardPageTitle;